import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { useDragUploader } from "components/Pages/Home/Helpers/useDragUploader.js";
import { useState } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useContent } from "contexts/contentContext/contentContext";
import { UploaderHeader } from "components/Pages/Home/UploaderComponent/UploaderHeader/UploaderHeader.tsx";
import UploadFilesPreview from "components/Pages/Home/UploaderComponent/UploadFilesPreview.js";
import { UploaderEmptyDragArea } from "components/Pages/Home/UploaderComponent/UploaderEmptyDragArea/UploaderEmptyDragArea";
import { UploaderFooter } from "components/Pages/Home/UploaderComponent/UploaderFooter.js";
import styles from "./styles.module.scss";

export const UploaderArea = () => {
  const { uploaderGetFiles, getUploading } = useUploader();
  const { handleDrop, handleDrag, dragged } = useDragUploader();
  const [listView, setListView] = useState(false);
  const { getTextByKey } = useContent();
  return (
    <div className={styles.wrap}>
      {uploaderGetFiles().length !== 0 ? (
        <div
          className={styles.workspace}
          onDrop={handleDrop}
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
        >
          {dragged && !getUploading() ? (
            <div className="drag-zone-highlight">
              <Icon name="upload-home" blue />
              <div className="drop-here-text">
                {getTextByKey("drop-here-text")}
              </div>
            </div>
          ) : null}
          <UploaderHeader setListView={setListView} listView={listView} />
          <UploadFilesPreview listView={listView} />
          <div className="flex-spacer"></div>
        </div>
      ) : (
        <UploaderEmptyDragArea {...{ handleDrop, handleDrag, dragged }} />
      )}
      <UploaderFooter />
    </div>
  );
};
